<!--
 * @Description: 
 * @Date: 2021-08-19 13:19:46
-->
<template>
  <el-checkbox
    @change="clickCheckAll"
    :checked="isChecked"
    :value="isChecked"
    :indeterminate="isCheckSome"
    label="全选"
    border
    :disabled="!hasNeedConfirm"
  ></el-checkbox>
</template>

<script>
import { canChoose } from '../tools/index';
export default {
  props: {
    projectList: {
      type: Array,
      default: () => []
    },
    chooseProjectList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    hasNeedConfirm() {
      return this.projectList.some(item =>
        item.list.some(info => {
          return canChoose(info);
        })
      );
    },
    needConfirmCount() {
      let count = 0;
      this.projectList.forEach(item =>
        item.list.forEach(info => {
          if (canChoose(info)) {
            count++;
          }
        })
      );
      return count;
    },
    isChecked() {
      return this.chooseProjectList.length > 0;
    },
    isCheckSome() {
      const { length } = this.chooseProjectList;
      return length > 0 && length < this.needConfirmCount;
    }
  },
  methods: {
    clickCheckAll() {
      if (this.isCheckSome || !this.isChecked) {
        // 选择了部分 或者 没有选择
        this.$emit(
          'chooseAll',
          this.projectList.reduce((pre, cur) => {
            pre.push(
              ...cur.list.reduce((p, c) => {
                canChoose(c) && p.push(c.id);
                return p;
              }, [])
            );
            return pre;
          }, [])
        );
      }
      if (this.isChecked && !this.isCheckSome) {
        // 选择了全部
        this.$emit('chooseAll', []);
      }
    }
  }
};
</script>

<style></style>
